import { useCompoundBody } from "@react-three/cannon"
import { useGLTF } from "@react-three/drei"
import { useRef } from "react"
import { Group, Material, Mesh } from "three"
import { ObjectProps, useDragConstraint } from "../utils"
import { asset } from "../../consts"
import type { GLTF } from "three-stdlib/loaders/GLTFLoader";

interface ComputerClosetHangerGLTF extends GLTF {
  materials: {
    default: Material
    Liquid: Material
  }
  nodes: {
    'Node-Mesh': Mesh
    'Node-Mesh_1': Mesh
  }
}
export default ({position, rotation}: ObjectProps) => {
  const { nodes, materials } = useGLTF(asset('/models/ClosetHanger.glb')) as any as ComputerClosetHangerGLTF
  const [ref] = useCompoundBody(() => ({
    angularDamping: 0.5,
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [0.3, 1.8, 0], type: 'Cylinder', rotation: [0, 0, Math.PI / 6] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [0.15, 2, 0], type: 'Cylinder', rotation: [0, 0, Math.PI / 3] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [-0.08, 2.05, 0], type: 'Cylinder', rotation: [0, 0, Math.PI / 2] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [-0.255, 1.95, 0], type: 'Cylinder', rotation: [0, 0, -Math.PI / 4] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [-0.325, 1.815, 0], type: 'Cylinder', rotation: [0, 0, 0] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [-0.255, 1.615, 0], type: 'Cylinder', rotation: [0, 0, Math.PI / 6] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [-0.145, 1.515, 0], type: 'Cylinder', rotation: [0, 0, Math.PI / 3] },
      { args: [0.05, 0.05, 0.2], mass: 0.1, position: [0, 1.315, 0], type: 'Cylinder', rotation: [0, 0, 0] },

      { args: [3, 0.3, 0.3], mass: 0.4, position: [1, 0.35, 0], type: 'Box', rotation: [0, 0, -Math.PI / 6] },
      { args: [3, 0.3, 0.3], mass: 0.4, position: [-1, 0.35, 0], type: 'Box', rotation: [0, 0, Math.PI / 6] },

      { args: [0.05, 0.05, 4], mass: 0.2, position: [0, -0.415, 0], type: 'Cylinder', rotation: [0, 0, Math.PI / 2] },
    ], 
    material: {
      friction: 0.8,
      restitution: 0.6,
    },
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind} dispose={null}>
      <group scale={[1, 1, 1]}>
        <mesh
          position={[0, -1, 0]} rotation={[0, Math.PI, 0]}
          receiveShadow
          castShadow
          material={materials.default}
          geometry={nodes['Node-Mesh'].geometry}
        />
        <mesh
          position={[0, -1, 0]}
          receiveShadow
          castShadow
          material={materials.default}
          geometry={nodes['Node-Mesh_1'].geometry}
        />
      </group>
    </group>
  );
};

